import { createError } from './createError';

export const argumentError = (message = 'Invalid argument') => {
    return createError(message, 'ArgumentError');
};
